import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import config from 'config/config';
import checkOrSetSlash from 'utils/checkOrSetSlash';
import { prepareFCHeader } from 'utils/request';

const rootProjectPath = `${checkOrSetSlash(config.apiHostGateway, 'apiHostGateway')}api/`;

export const observationsApi = createApi({
  reducerPath: 'observationsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: rootProjectPath,
    prepareHeaders: prepareFCHeader(),
  }),
  tagTypes: ['Observations'],
  endpoints: builder => ({
    fetchObservationLinkedItems: builder.query({
      query: ({ projectId, ids }) => ({
        url: `projects/${projectId}/observations/linked-items`,
        method: 'POST',
        body: JSON.stringify({ ids }),
      }),
      transformResponse: response =>
        response.values.map(value => ({
          ...value,
          isDeleted: value?.is_deleted,
          moduleId: value?.module_id,
          statusColor: value?.color,
          num: value?.legacy_id,
        })),
    }),
    unlinkItems: builder.mutation({
      query: ({ ids, projectId }) => ({
        url: `projects/${projectId}/unlink-items`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(ids),
      }),
    }),
  }),
});

export const { useFetchObservationLinkedItemsQuery } = observationsApi;
